import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const CertificateIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 14.3 22"
    >
      <g transform="translate(1 1)">
        <path
          d="M1364.118,200.57a2.681,2.681,0,0,0-2.707-2.654,2.758,2.758,0,0,0-.76.108,2.707,2.707,0,0,0-5.4-.009,2.746,2.746,0,0,0-.725-.1,2.681,2.681,0,0,0-2.707,2.654,2.613,2.613,0,0,0,.628,1.7,2.608,2.608,0,0,0-.628,1.7,2.681,2.681,0,0,0,2.707,2.654,2.745,2.745,0,0,0,.731-.1,2.712,2.712,0,0,0,5.389-.008,2.758,2.758,0,0,0,.766.109,2.681,2.681,0,0,0,2.707-2.654,2.609,2.609,0,0,0-.628-1.7A2.613,2.613,0,0,0,1364.118,200.57Z"
          transform="translate(-1351.818 -195.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1353.713,206.5v9l4.255-3.809,4.35,3.809v-9"
          transform="translate(-1351.818 -195.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
